// extracted by mini-css-extract-plugin
export default {"bodywrapper":"adminpage_bodywrapper__VmY8H"};